type HomeownerInspection = {
  homeUniqueId?: string;
  type?: string;
  isHandledByAnExternalProvider?: boolean;
};

export const findOnboardingInspection = (
  inspections: HomeownerInspection[] | undefined,
  unitId: string | undefined,
) =>
  inspections?.find(
    (inspection) =>
      inspection.homeUniqueId === unitId && inspection.type === 'Onboarding',
  );
